import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade createNewModal",
  id: "AddModalAffectation",
  tabindex: "-1",
  ref: "addAffectationModalRef",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content p-15 p-md-40" }
const _hoisted_4 = { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }
const _hoisted_5 = { class: "modal-title fw-bold text-black" }
const _hoisted_6 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "form-group mb-25" }
const _hoisted_10 = { class: "form-control-plaintext fs-16 fw-medium" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = {
  key: 0,
  class: "text-danger mt-1"
}
const _hoisted_14 = { class: "col-12 text-end" }
const _hoisted_15 = {
  type: "submit",
  class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.title), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Form, {
            ref: "affectationForm",
            onSubmit: _ctx.addAffectation,
            "validation-schema": _ctx.affectationSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", _hoisted_10, [
                      _cache[2] || (_cache[2] = _createTextVNode(" Voulez-vous vraiment affecter la file ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.selectedFileLabel), 1),
                      _cache[3] || (_cache[3] = _createTextVNode(" à des agents ? ", -1))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Utilisateurs "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "user" }, {
                      default: _withCtx(({ field, errorMessage }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          modelValue: _ctx.selectedUsers,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedUsers) = $event))
                        }, field, {
                          options: _ctx.userOptions,
                          searchable: true,
                          multiple: true,
                          mode: "tags",
                          "track-by": "value",
                          label: "label",
                          placeholder: "Sélectionner un ou plusieurs utilisateurs",
                          class: { 'is-invalid': errorMessage }
                        }), null, 16, ["modelValue", "options", "class"]),
                        errorMessage
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(errorMessage), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "user",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", _hoisted_15, _toDisplayString(_ctx.btntext), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn-close shadow-none",
          "data-bs-dismiss": "modal",
          "aria-label": "Close",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetValue()))
        })
      ])
    ])
  ], 512))
}